<template>
    <img
        :src="contacts.logo_path"
        alt="Home Deli Logo"
        class="tw-h-10 xl:tw-h-20 tw-w-auto"
        v-if="contacts && contacts.logo_path !== ''"
    />
    <img
        :src="src ?? '/img/homedeli.jpg'"
        class="tw-h-20 tw-w-auto"
        alt="Home Deli Logo"
        v-else
    />
</template>

<script setup lang="ts">
import { useContactsStore } from "~/stores/contactsStore"

/**
 *
 *  Props and emits section
 *
 *
 */

defineProps<{
    height?: string
    width?: string
    class?: string
    src?: string
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const contactsStore = useContactsStore()
const { contacts } = storeToRefs(contactsStore)

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>
